import { render, staticRenderFns } from "./IndexSwiper.vue?vue&type=template&id=a8dde4a2&scoped=true&"
import script from "./IndexSwiper.vue?vue&type=script&lang=js&"
export * from "./IndexSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dde4a2",
  null
  
)

export default component.exports